import { render, staticRenderFns } from "./uploadTab.vue?vue&type=template&id=3a4b27b4&scoped=true&"
import script from "./uploadTab.vue?vue&type=script&lang=js&"
export * from "./uploadTab.vue?vue&type=script&lang=js&"
import style0 from "./uploadTab.vue?vue&type=style&index=0&id=3a4b27b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b27b4",
  null
  
)

export default component.exports